export default __webpack_public_path__ + "static/media/watchlistIcon.411e58c1.svg";